// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-upload-preview[data-v-d5d9e018] {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(50%, -50%);\n          transform: translate(50%, -50%);\n  width: 180px;\n  height: 180px;\n  border-radius: 50%;\n  -webkit-box-shadow: 0 0 4px #ccc;\n          box-shadow: 0 0 4px #ccc;\n  overflow: hidden;\n}\n.avatar-upload-preview img[data-v-d5d9e018] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
